import React from "react";
import { Modal, Form, Input, Row, Col, Card, Button, Switch } from "antd";
import { MonnaieService } from "../../services/MonnaieService";
import Toast from "../../helpers/Toast";
import PropTypes from "prop-types";
import { catchError } from "../../services/DaoService";
import CustomFormItem from "../utils/form/CustomFormItem";
import style from "./MonnaieCreateForm.module.scss";

const MonnaieCreateForm = ({ visible, onCreate, onCancel }) => {
  const [form] = Form.useForm();
  const [creating, setCreating] = React.useState(false);
  const [validationErrors, setValidationErrors] = React.useState({});

  const handleSave = () => {
    setCreating(true);
    form
      .validateFields()
      .then((values) => {
        MonnaieService.getInstance()
          .create(values)
          .then((response) => {
            Toast.success(response.message);
            form.resetFields();
            onCreate(response.data);
          })
          .catch((error) => {
            const errors = error.response.data;
            if (errors.validation && Object.keys(errors?.errors).length) {
              setValidationErrors(errors.errors);
            } else {
              catchError(error);
            }
          })
          .finally(() => {
            setCreating(false);
          });
      })
      .catch(() => {
        setCreating(false);
      });
  };

  return (
    <Modal
      open={visible}
      onCancel={onCancel}
      title="Créer une nouvelle monnaie"
      footer={[
        <>
          <Row gutter={24}>
            <Col>
              <Button
                key="cancel"
                onClick={onCancel}
                className={style.ButtonNew}
              >
                Annuler
              </Button>
            </Col>
            <Col>
              <Button
                key="save-again"
                type="primary"
                loading={creating}
                onClick={() => handleSave()}
                className={style.ButtonNew}
              >
                Enregistrer et Créer
              </Button>
            </Col>
          </Row>
        </>
      ]}
    >
      <Card style={{ marginBottom: 5 }}>
        <Form
          layout="vertical"
          form={form}
          name="createMonnaieForm"
          initialValues={{
          }}
        >
          <Row gutter={24}>
            <Col xs={24} md={24} lg={24}>
              <CustomFormItem
                label="Nom"
                name="nom"
                rules={[{ required: true, message: "Veuillez saisir le nom !" }]}
                validationErrors={validationErrors}
                setValidationErrors={setValidationErrors}
              >
                <Input type="text" />
              </CustomFormItem>
            </Col>
            <Col xs={24} md={24} lg={24}>
              <CustomFormItem
                label="Code"
                name="code"
                rules={[{ required: true, message: "Veuillez saisir le code !" }]}
                validationErrors={validationErrors}
                setValidationErrors={setValidationErrors}
              >
                <Input type="text" />
              </CustomFormItem>
            </Col>
          </Row>

          <Row gutter={24}>
            <Col xs={24} md={24} lg={24}>
              <CustomFormItem
                label="Symbole"
                name="symbole"
                rules={[{ required: true, message: "Veuillez saisir le symbole !" }]}
                validationErrors={validationErrors}
                setValidationErrors={setValidationErrors}
              >
                <Input type="text" />
              </CustomFormItem>
            </Col>
            <Col xs={24} md={24} lg={24}>
              <CustomFormItem
                label="Monnaie par défaut" help="La monnaie par défaut sera utilisée pour les montants. Seule une monnaie peut être définie comme monnaie par défaut."
                name="current"
                validationErrors={validationErrors}
                setValidationErrors={setValidationErrors}
                valuePropName="checked"
              >
                <Switch />
              </CustomFormItem>
            </Col>
          </Row>

        </Form>
      </Card>
    </Modal>
  );
};

export default MonnaieCreateForm;

MonnaieCreateForm.propTypes = {
  visible: PropTypes.bool,
  onCreate: PropTypes.func,
  onCancel: PropTypes.func
};
